/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 17:24:02
 * @LastEditors: jikeychang@gmail.com
 * @LastEditTime: 2021-03-03 17:29:16
 * @Description: FileDescription
 */
import dbDic from '@/api/dataDictionary'; // 对应api-js路径

export default {
  namespaced: true,
  state: {
    dataDictionaryList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    dataDictionaryDetail: [],
  },
  actions: {
    /**
     * 数据字典
     */
    // 获取:系统数据源
    getSystemSources(state, param) {
      return dbDic.getSystemSources(param).then(prod => prod);
    },
    // 获取:数据字典
    getDataDictionaryList({ commit }, param) {
      return dbDic.getDataDictionaryList(param).then((prod) => {
        commit('setDataDictionaryList', prod);
      });
    },
    // 查看:数据字典
    dtlDataDictionaryList({ commit }, param) {
      return dbDic.dtlDataDictionaryList(param).then((prod) => {
        commit('setDataDictionaryDetail', prod);
      });
    },
    // 删除:数据字典
    delDataDictionaryList(store, param) {
      return dbDic.delDataDictionaryList(param).then(prod => prod);
    },
    // 新增:数据字典
    addDataDictionaryList(store, param) {
      return dbDic.addDataDictionaryList(param).then(prod => prod);
    },
    // 编辑:数据字典
    editDataDictionaryList(store, param) {
      return dbDic.editDataDictionaryList(param).then(prod => prod);
    },
  },
  mutations: {
    /**
     * 数据字典
     */
    // table数据字段赋值
    setDataDictionaryList(state, content) {
      const { list, pageNum, total } = content.page;
      state.dataDictionaryList.list = list;
      state.dataDictionaryList.pageNum = pageNum;
      state.dataDictionaryList.total = total;
    },
    setDataDictionaryDetail(state, content) {
      state.dataDictionaryDetail = content.list;
    },
  },
};
